export class DocumentErrorHelper {
    public static GetMessage(statusCode: number): string {
        switch (statusCode) {
            case 404:
                return "We were unable to find that document";
            case 0:
                return "We couldn't connect to the server";
            default:
                return "Something went wrong";
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/error-helper.ts